/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dimmer, Loader, Segment } from "semantic-ui-react";
import { selectCurrentUserAdmin, selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getDuplicateTitles = async (apiToken, setAdminState) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getduplicatetitles");
    await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getduplicatetitles',
            'apiToken': apiToken,
            'analyticsBypass': true
        },
    }).then((resp) => {
        if (resp?.data?.success) {
            setAdminState(prevState => {
                return { ...prevState, "resourceTypesAndTitlesAndFois": resp.data.resourceTypesAndTitlesAndFois, "loading": false };
            });
            return resp.data;
        } else {
            //return { ...prevState, "loading": false };
        }
        console.log("NO RESPONSE from getduplicatetitles call");
    }).catch((error) => { console.log(error); });
}

const retireFoiSet = async (apiToken, fois, resourceType, title, setRetiredRowState) => {
    if (fois) {
        if (!apiToken) {
            console.log("no apiToken");
            return null;
        }
        console.log("CALLING SERVER with retireresources");
        await axiosInstance({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                'functionid': 'retireresources',
                'apiToken': apiToken,
                'fois': fois,
                'analyticsBypass': true
            },
        }).then((resp) => {
            if (resp?.data?.success) {
                console.log("success: " + fois);
                setRetiredRowState(prevState => {
                    if (!prevState[resourceType]) {
                        return { ...prevState, [resourceType]: { [title]: fois } };
                    } else if (!prevState[resourceType][title]) {
                        return { ...prevState, [resourceType]: { ...prevState[resourceType], [title]: fois } };
                    } else {
                        return { ...prevState, [resourceType]: { ...prevState[resourceType], [title]: [... new Set([...prevState[resourceType][title], ...fois])] } }; //new Set([]) to make sure there are no repeats
                    }
                });
            } else {
                console.log("failed: " + fois);
            }
            console.log("NO RESPONSE from retireresources call: " + fois);
        }).catch((error) => { console.log(error + ": " + fois); });
    }
}

const FoiSet = ({ apiToken, resourceType, title, fois, retiredRowState, setRetiredRowState, rowRetired, rowAllButOneRetired }) => {
    const [selectedState, setSelectedState] = useState();
    return <fieldset>
        {(selectedState && !rowRetired && !rowAllButOneRetired) && <><button onClick={() => { retireFoiSet(apiToken, fois.filter(item => item != selectedState), resourceType, title, setRetiredRowState); }}>Retire the Other FOIs</button>&nbsp;&nbsp;&nbsp;</>}
        {fois.map((id, i) => {
            const resourceTypeAndId = resourceType + "/" + id;
            const retiredResource = retiredRowState?.[resourceType]?.[title]?.includes(id);
            return <span key={i}>
                {(!rowRetired && !rowRetired && !rowAllButOneRetired) && <input type="radio" id={id} name={resourceType + ":" + title} value={id} onChange={(event) => { setSelectedState(event.target.value); }} />}
                <label for={id}>
                    <a href={"/" + resourceTypeAndId}
                        target="_blank" rel="noopener noreferrer"
                        style={{ color: retiredResource && "red" }}>{id}</a>
                    {i < (fois.length - 1) && ", "}
                </label>
            </span>
        })}
    </fieldset>
}

// eslint-disable-next-line no-empty-pattern
const AdminPage2 = ({ }) => {
    const dispatch = useDispatch();

    const isAdmin = useSelector(selectCurrentUserAdmin);
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [adminState, setAdminState] = useState({
        "loading": true,
        "startedToLoad": true,
        "resourceTypesAndTitlesAndFois": null
    });

    const [retiredRowState, setRetiredRowState] = useState({});

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Admin"));
    }, []);

    useEffect(() => {
        if (isAdmin && adminState.startedToLoad) {
            setAdminState(prevState => { return { ...prevState, startedToLoad: false }; });
            getDuplicateTitles(apiToken, setAdminState);
        } else if (isAdmin && adminState.loading) {
            //setAdminState(prevState => { return { ...prevState, loading: false }; });
        }
    }, [adminState]);

    return <>
        {isAdmin &&
            <div>
                <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                    <div>
                        {adminState.loading &&
                            <Dimmer className={"loadingDimmer"} active inverted>
                                <Loader inverted>Loading</Loader>
                            </Dimmer>
                        }
                        <span style={{ width: "100%", textAlign: "center" }}>
                            <h3>Admin Dashboard 2</h3>
                        </span>
                        <br />
                        {adminState?.resourceTypesAndTitlesAndFois &&
                            <table><tbody>{Object.keys(adminState.resourceTypesAndTitlesAndFois).map((resourceType, index) => {
                                return <>
                                    {Object.keys(adminState.resourceTypesAndTitlesAndFois[resourceType]).map((title, index) => {
                                        const fois = adminState.resourceTypesAndTitlesAndFois[resourceType][title];
                                        const resourceTypeAndTitle = resourceType + ": " + title;
                                        const rowRetired = retiredRowState?.[resourceType]?.[title]?.length === fois.length;
                                        const rowAllButOneRetired = retiredRowState?.[resourceType]?.[title]?.length === fois.length - 1;
                                        return <tr key={index} style={{ backgroundColor: rowRetired && "#EE9999" }}>
                                            <td>{resourceTypeAndTitle}{!rowRetired && <> <button onClick={() => { retireFoiSet(apiToken, fois, resourceType, title, setRetiredRowState); }}>Retire All</button></>}</td>
                                            <td>
                                                <FoiSet apiToken={apiToken} resourceType={resourceType} title={title} fois={fois} rowRetired={rowRetired} rowAllButOneRetired={rowAllButOneRetired} retiredRowState={retiredRowState} setRetiredRowState={setRetiredRowState} />
                                            </td>
                                        </tr>
                                    })}
                                </>
                            })}</tbody></table>
                        }
                        <br />
                        <br />
                    </div>
                </Segment>
            </div>
        }
    </>
}

export default AdminPage2;